export function renderPagination(currentPage) {
    if (totalPosts <= 12) return
    const currentUrl = window.location.href;
    const path = window.location.pathname;
    let dataPost = '';
    if (path.includes('for-parents')) {
        dataPost = 'parents'
    } else if (path.includes('articles')) {
        dataPost = 'news'
    }
    const postsPerPage = 12;
    const totalPages = Math.ceil(totalPosts / postsPerPage);

    // Контейнер пагинации
    const paginationContainer = $('.pagination__pages');
    paginationContainer.empty();

    // Если страниц меньше или равно 7, отображаем все
    if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
            paginationContainer.append(`<button class="pagination__button ${i === currentPage ? 'active' : ''}" data-page="${i}" data-post-type="${dataPost}">${i}</button>`);
        }
    } else {

        let start, end, firstRender, secondRender;

        if (window.innerWidth <= 620) {
            firstRender = 2
            secondRender = 4
            start = Math.max(currentPage - 1, 3); // Начинаем с currentPage - 3, но не раньше 2
            end = Math.min(currentPage + 1, totalPages - 1); // Заканчиваем currentPage + 3, но не больше totalPages - 1
        } else {
            firstRender = 5
            secondRender = 5
            start = Math.max(currentPage - 1, 3); // Начинаем с currentPage - 3, но не раньше 2
            end = Math.min(currentPage + 1, totalPages - 1); // Заканчиваем currentPage + 3, но не больше totalPages - 1
        }
        // Всегда показываем 7 элементов

        // Если мы на первой странице или близки к первой
        if (currentPage === 1) {
            paginationContainer.append(`<button class="pagination__button ${1 === currentPage ? 'active' : ''}" data-page="1" data-post-type="${dataPost}">1</button>`);
            for (let i = 2; i <= firstRender; i++) {
                paginationContainer.append(`<button class="pagination__button ${i === currentPage ? 'active' : ''}" data-page="${i}" data-post-type="${dataPost}">${i}</button>`);
            }
            paginationContainer.append('<span class="pagination__dots">...</span>');
            paginationContainer.append(`<button class="pagination__button ${totalPages === currentPage ? 'active' : ''}" data-page="${totalPages}" data-post-type="${dataPost}">${totalPages}</button>`);
        }
        // Если мы на последней странице или близки к последней
        else if (currentPage === totalPages) {
            paginationContainer.append(`<button class="pagination__button ${1 === currentPage ? 'active' : ''}" data-page="1" data-post-type="${dataPost}">1</button>`);
            paginationContainer.append('<span class="pagination__dots">...</span>');
            for (let i = totalPages - 4; i <= totalPages - 1; i++) {
                paginationContainer.append(`<button class="pagination__button ${i === currentPage ? 'active' : ''}" data-page="${i}" data-post-type="${dataPost}">${i}</button>`);
            }
            paginationContainer.append(`<button class="pagination__button ${totalPages === currentPage ? 'active' : ''}" data-page="${totalPages}" data-post-type="${dataPost}">${totalPages}</button>`);
        }
        // Когда текущая страница где-то в середине
        else {
            paginationContainer.append(`<button class="pagination__button ${1 === currentPage ? 'active' : ''}" data-page="1" data-post-type="${dataPost}">1</button>`);

            // Показать троеточие, если есть пропущенные страницы между первой и текущей
            if (currentPage > 3) {
                paginationContainer.append('<span class="pagination__dots">...</span>');
            }
            if (currentPage < 4) {
                // Показать страницы вокруг текущей
                for (let i = 2; i <= secondRender; i++) {
                    paginationContainer.append(`<button class="pagination__button ${i === currentPage ? 'active' : ''}" data-page="${i}" data-post-type="${dataPost}">${i}</button>`);
                }
            } else if (currentPage < totalPages - 3 ) {
                for (let i = start; i <= end; i++) {
                    paginationContainer.append(`<button class="pagination__button ${i === currentPage ? 'active' : ''}" data-page="${i}" data-post-type="${dataPost}">${i}</button>`);
                }
            }

            // Показать троеточие, если есть пропущенные страницы между текущей и последней
            if (currentPage < totalPages - 3) {
                paginationContainer.append('<span class="pagination__dots">...</span>');
            } else if (currentPage >= totalPages - 3) {
                for (let i = totalPages - 4; i <= totalPages - 1; i++) {
                    paginationContainer.append(`<button class="pagination__button ${i === currentPage ? 'active' : ''}" data-page="${i}" data-post-type="${dataPost}">${i}</button>`);
                }
            }

            paginationContainer.append(`<button class="pagination__button ${totalPages === currentPage ? 'active' : ''}" data-page="${totalPages}" data-post-type="${dataPost}">${totalPages}</button>`);
        }
    }
}


function ajaxChangePage(ajaxUrl, page, clickArrow, postType) {
    const loadButton = $('#loadMorePosts');
    const wrapper = $('.card-list__wrapper')

    $.ajax( {
        url: ajaxUrl,
        method: 'POST',
        data: {
            action: 'handle_change_page',
            page: page,
            postType: postType
        },
        success: function (response) {
            $('html, body').animate({
                scrollTop: 0
            }, 700);
            wrapper.empty()
            wrapper.append(response)

            const newPosts = wrapper.find('.card')
            newPosts.each(function (index, post) {
                $(post).css('display', 'flex')
                    .hide()
                    .fadeIn(1000)
                    .removeClass('card-disable')
                    .css('display', '')
            });

            if (page * 12 >= totalPosts) {
                loadButton.addClass('card-list__more-disable')
            } else {
                loadButton.removeClass('card-list__more-disable')
            }

            wrapper.removeClass('card-list__more-loading')
            if (!clickArrow) {
                renderPagination(page)
            }
        },
        error: function(xhr, status, error) {
            console.log('Ошибка AJAX: ' + error);
            $(this).removeClass('card-list__more-loading')
        }
    } )
}

function ajaxLoadMorePosts (ajaxUrl, offset, loadButton, postType) {
    const wrapper = $('.card-list__wrapper')
    console.log(offset)
    $.ajax( {
        url: ajaxUrl,
        method: 'POST',
        data: {
            action: 'load_more_posts',
            offset: offset,
            postType: postType
        },
        success: function (response) {
            wrapper.append(response)

            const newPosts = wrapper.find('.card-disable')
            newPosts.each(function (index, post) {
                $(post).css('display', 'flex') // Устанавливаем display: flex
                    .hide() // Скрываем элемент перед анимацией
                    .fadeIn(700)
                    .removeClass('card-disable')
                    .css('display', '')
            });

            if (wrapper.children().length >= totalPosts) {
                loadButton.addClass('card-list__more-disable')
            }
            loadButton.removeClass('card-list__more-loading')
        },
        error: function(xhr, status, error) {
            console.log('Ошибка AJAX: ' + error);
            loadButton.removeClass('card-list__more-loading')
        }
    } )
}

export function handleClickLoadMorePosts(ajaxUrl) {
    const loadButton = $('#loadMorePosts');
    let offset = loadButton.data('offset')
    let postType = loadButton.data('post-type')

    loadButton.on('click', function () {
        $(this).addClass('card-list__more-loading')

        if (offset >= totalPosts) {
            $(this).addClass('card-list__more-disable')
        } else {
            ajaxLoadMorePosts(ajaxUrl, offset, loadButton, postType)
            offset += 12
        }
    });
}


export function handleClickPaginationButton(ajaxUrl) {
    $(document).on('click', '.pagination__button', function () {
        const postType = $(this).data('post-type')
        if (($(this).hasClass('active'))) {
            return
        }

        $(this).addClass('active')
        $('.pagination__button').removeClass('active')

        const page = $(this).data('page')

        ajaxChangePage(ajaxUrl, page, false, postType)
    })
}

export function handleClickNextPage(ajaxUrl) {
    const totalPages = Math.ceil(totalPosts / 12);
    $(document).on('click',  '.pagination__next', function () {
        const page = $('.pagination__button.active').data('page')
        const postType = $(this).data('post-type')
        if (page === totalPages) {
            return
        }

        ajaxChangePage(ajaxUrl, page + 1, true, postType)
        renderPagination(page + 1)
    })
}

export function handleClickPrevPage(ajaxUrl) {
    $(document).on('click',  '.pagination__prev', function () {
        const page = $('.pagination__button.active').data('page')
        const postType = $(this).data('post-type')
        if (page === 1) {
            return
        }

        ajaxChangePage(ajaxUrl, page - 1, true, postType)
        renderPagination(page - 1)
    })
}